import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Raven from 'raven-js';
import { Component } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: undefined
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: {
        errorInfo,
        objectId: this.props.objectId,
        objectTypeId: this.props.objectTypeId,
        objectType: this.props.objectType
      }
    });
  }
  render() {
    const {
      ErrorMarker
    } = this.props;
    if (!this.state.error) {
      return this.props.children;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [ErrorMarker && /*#__PURE__*/_jsx(ErrorMarker, {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "cardProperties.cardError_jsx",
        options: {
          href: window.location.href
        },
        elements: {
          Link
        }
      })]
    });
  }
}